import { useHistory } from 'react-router-dom';
import React, { useState, useCallback } from 'react';
import { Tabs, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Switch } from 'react-router-dom';
import GenericFilterParamLogListBrowser from 'features/logs/components/genericFilterParamLogs/GenericFilterParamLogListBrowser';
import SystemLogListBrowser from 'features/logs/components/systemLogs/list/SystemLogListBrowser';
import EvaluationLogListBrowser from 'features/logs/components/evaluationLogs/EvaluationLogListBrowser';
import PrivateRoute from 'components/routing/PrivateRoute';
import { initialLogTabs } from './constants';
import LogDetailContainer from 'features/logs/components/systemLogs/edit/LogDetailContainer';
import { LogAppBar } from './LogStyles';

const LogRouteStepper = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const getCurrentTab = () => {
    if (history.location.pathname === initialLogTabs.genericFilterParamLogs.route) {
      return initialLogTabs.genericFilterParamLogs.value;
    }
    if (history.location.pathname === initialLogTabs.evaluationLogs.route) {
      return initialLogTabs.evaluationLogs.value;
    }
    return initialLogTabs.logs.value;
  };

  const [activeTab, setActiveTab] = useState(getCurrentTab());

  const handleBackToListClick = useCallback(() => {
    history.push(initialLogTabs.logs.route);
  }, [history]);

  const handleChange = (_, tab) => {
    if (tab === activeTab) return;

    switch (tab) {
      case initialLogTabs.logs.value:
        history.push(initialLogTabs.logs.route);
        break;
      case initialLogTabs.genericFilterParamLogs.value:
        history.push(initialLogTabs.genericFilterParamLogs.route);
        break;
      case initialLogTabs.evaluationLogs.value:
        history.push(initialLogTabs.evaluationLogs.route);
        break;
      default:
        history.push(initialLogTabs.logs.route);
        break;
    }
    setActiveTab(tab);
  };
  return (
    <>
      <LogAppBar position='static' color='default'>
        <Tabs value={activeTab} onChange={handleChange} indicatorColor='primary' textColor='primary' variant='scrollable'>
          <Tab label={t('Logs.Logs')} value={initialLogTabs.logs.value} onClick={handleBackToListClick} />
          <Tab label={t('GenericFilterParamLogs.GenericFilterParamLogs')} value={initialLogTabs.genericFilterParamLogs.value} />
          <Tab label={t('EvaluationLogs.EvaluationLogs')} value={initialLogTabs.evaluationLogs.value} />
        </Tabs>
      </LogAppBar>
      <Switch>
        <PrivateRoute exact path='/logs/systemLogs' component={SystemLogListBrowser} />
        <PrivateRoute exact path='/logs/systemLogs/:correlationId' component={SystemLogListBrowser} />
        <PrivateRoute exact path='/logs/systemLogs/logDetail/:id' component={LogDetailContainer} />
        <PrivateRoute exact path='/logs/genericFilterParamLogs' component={GenericFilterParamLogListBrowser} />
        <PrivateRoute exact path='/logs/evaluationLogs' component={EvaluationLogListBrowser} />
      </Switch>
    </>
  );
};

export default LogRouteStepper;
